__turbopack_context__.v({
  "canvas": "animation-module-scss-module__iexpfW__canvas",
});
